import { render, staticRenderFns } from "./QaDashboard.vue?vue&type=template&id=a2e08e66&scoped=true&"
import script from "./QaDashboard.vue?vue&type=script&lang=js&"
export * from "./QaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./QaDashboard.vue?vue&type=style&index=0&id=a2e08e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e08e66",
  null
  
)

export default component.exports